// src/template-library/Header/TemplateHeader1.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader1.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader1 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo ; 
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName =  branding?.brandName || user?.brandName ||  "Travel Agency";

  const handleNavClick = (e, item) => {
      const viewName = item.path === "/" ? "home" : item.path.replace('/', '');
  if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    } 
    // 2. PREVIEW MODE (Scenario 2)
    else if (mode === "preview") {
      e.preventDefault();
      // Redirect to the URL that includes the template context
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // 3. LIVE MODE (Scenario 3)
    else {
      // Do nothing, let the standard <Link> handle it (e.g. /destinations)
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
  <Link
  to="/"
  onClick={(e) => {
    e.preventDefault(); // 🔥 stops navigation
    handleNavClick(e, { path: "/" });
  }}
>
    {logoUrl ? (
      <img src={logoUrl} alt={brandName} className={styles.logoImage} />
    ) : (
      <h2 className={styles.textLogo}>{brandName}</h2>
    )}
  </Link>
</div>

        <div className={styles.rightSection}>
            <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
              <ul className={styles.navList}>
                {headerMenu.map((item) => (
                  <Link 
          key={item.id} 
          to={item.path} 
          onClick={(e) => handleNavClick(e, item)} className={styles.navLink}>
                      {item.label}
                    </Link>
                 
                ))}
               
              </ul>
            </nav>
            <div className={styles.ctaContainer}>
                <button className={styles.bookBtn}>Book Now</button>
            </div>
            <div className={styles.mobileToggle} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
        </div>
      </div>
    </header>
  );
};

export default TemplateHeader1;